// 5 PWA cài được (QĐ anh David 01/Nov 10:12 + 10:16): HANA Hub (phạm vi /, gồm Mee · Edu · Kit và Trang chủ), HANA Ezy (/ezy/, dùng nhiều nhất),
// HANA Box (/box/), HANA Mov (/mov/), HANA Hei (/hei/, bản dựng riêng trong apps/hei). Service worker dùng chung trong Hub.
const OWN = ['ezy', 'box', 'mov'] as const; // vùng có manifest riêng trong bản dựng Hub; còn lại dùng manifest Hub

/** Vùng có PWA riêng của đường dẫn (`/box/mail` → `box`); vùng khác (Mee, Edu, Kit…) thuộc PWA Hub → null. */
export function zoneOf(pathname: string): (typeof OWN)[number] | null {
  const k = pathname.split('/')[1];
  return OWN.find((z) => z === k) ?? null;
}

/** Màu thanh tiêu đề PWA / thanh trình duyệt theo vùng = màu nền icon app (QĐ anh David 31/Oct 12:2x: tăng nhận diện vùng). */
// token-ok: meta theme-color và manifest không đọc được biến CSS — giá trị khớp packages/ui/src/icons/apps/*.svg
export const ZONE_THEME: Record<string, string> = { ezy: '#005B85', box: '#0098D6', mee: '#B83F88', edu: '#7457DB', mov: '#C62828', hei: '#1A9BFC' }; // token-ok: màu icon app
export const HUB_THEME = '#F5F7FB'; // token-ok: nền Hub (trùng meta trong index.html)

/** Màu theme-color của đường dẫn (vùng → màu vùng, ngoài vùng → nền Hub). */
export function themeColorOf(pathname: string): string {
  return ZONE_THEME[pathname.split('/')[1] ?? ''] ?? HUB_THEME;
}

/** Manifest của đường dẫn: Ezy / Box / Mov có manifest riêng, mọi chỗ khác dùng manifest HANA Hub. */
export function manifestHref(pathname: string): string {
  const z = zoneOf(pathname);
  return z ? `/${z}.webmanifest` : '/hub.webmanifest';
}

/** Gắn manifest theo đường dẫn đang mở (Hub hoặc Box / Mov) và đổi màu thanh tiêu đề theo vùng. */
export function syncManifest(pathname: string, doc: Document = document): void {
  syncThemeColor(pathname, doc);
  const href = manifestHref(pathname);
  let link = doc.querySelector<HTMLLinkElement>('link[rel="manifest"]');
  if (!link) {
    link = doc.createElement('link');
    link.rel = 'manifest';
    doc.head.appendChild(link);
  }
  if (link.getAttribute('href') !== href) link.setAttribute('href', href);
}

/** Đổi <meta name="theme-color"> theo vùng đang mở (thanh tiêu đề PWA đã cài + thanh trình duyệt điện thoại). */
export function syncThemeColor(pathname: string, doc: Document = document): void {
  const c = themeColorOf(pathname);
  let m = doc.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (!m) {
    m = doc.createElement('meta');
    m.name = 'theme-color';
    doc.head.appendChild(m);
  }
  if (m.content !== c) m.content = c;
}

export function registerPwa(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  addEventListener('load', () => void navigator.serviceWorker.register('/sw.js').catch(() => undefined));
}
